import { useQuery } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

export default function useCustomerNotification(enabled: boolean) {

  const { shopMarketId } = useShop();

  const getCustomerNotifications = async () => {
    return await OpenapiSingleton.CustomerAPIV2Api.getCustomerNotifications(shopMarketId);
  };

  return useQuery<any>({
    queryKey: ["customerNotification"],
    queryFn: getCustomerNotifications,
    enabled: enabled
  });

}
